import { render, staticRenderFns } from "./HJ01572.vue?vue&type=template&id=52dff237&scoped=true&"
import script from "./HJ01572.vue?vue&type=script&lang=js&"
export * from "./HJ01572.vue?vue&type=script&lang=js&"
import style0 from "./HJ01572.vue?vue&type=style&index=0&id=52dff237&prod&lang=less&scoped=true&"
import style1 from "./HJ01572.vue?vue&type=style&index=1&id=52dff237&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dff237",
  null
  
)

export default component.exports